const list = {
  // =================================================================================================================
  components() {
    return [
      {
        'component': 'search-start-end',
        label: '계약체결일',
        value: 'date',
        query: {'ss': 'startDate', 'ee': 'endDate'},
        options: {
          default: {sd: '', ed: ''},
        }
      },
      {
        'component': 'search-column-keyword',
        label: '검색조건',
        value: 'column',
        query: {'ck_t': 'head', 'ck_k': 'keyword'},
        options: {hiddenList: ['사업기간', '계약체결일']}
      },
    ]
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    //  검색일
    if (search.date) {
      const dateTarget = "body.stdInfo.custom_date";
      conditions.push({key: dateTarget, operator: '>=', value: search.date.startDate})
      conditions.push({key: dateTarget, operator: '<', value: search.date.endDate ? new Date(search.date.endDate).addDays(1).format("yyyy-MM-dd") : ''})
    }

    //  검색조건
    const heads = list.getHead().map(e => {return {[e.name] : e.key}});
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({key: types[search.column.head], operator: 'LIKE', value: `%${search.column.keyword}%`})
    }
    return conditions;
  },


  // =================================================================================================================
  getHead: () => {
    return [
      {
        "name": "구분",
        "key": "body.stdInfo.meta.구분"
      },
      {
        "name": "사업장명",
        "key": "body.stdInfo.field_name"
      },
      {
        "name": "담당주무관",
        "key": "body.stdInfo.담당주무관"
      },
      {
        "name": "사업기간",
        "key": "body.stdInfo.writer_name"
      },
      {
        "name": "계약체결일",
        "key": "body.stdInfo.custom_date"
      }
    ]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0: return func.getContent(value).stdInfo.meta.구분 // 구분
        case 1: return func.getContent(value).stdInfo.field_name // 사업장명
        case 2: return func.getContent(value).stdInfo.담당주무관 // 담당주무관
        case 3: return `${func.getContent(value).stdInfo.사업시작기간} ~ ${func.getContent(value).stdInfo.사업종료기간}` // 사업기간
        case 4: return func.getContent(value).stdInfo.custom_date // 계약체결일
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
}
export default list;
